import { render, staticRenderFns } from "./request-login.vue?vue&type=template&id=a4bb5c98&scoped=true&"
import script from "./request-login.vue?vue&type=script&lang=js&"
export * from "./request-login.vue?vue&type=script&lang=js&"
import style0 from "./request-login.vue?vue&type=style&index=0&id=a4bb5c98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb5c98",
  null
  
)

export default component.exports